import Vue from 'vue'
import swal from 'sweetalert2'
import App from './App'
import store from './store'
import router from './router'
import VCalendar from 'v-calendar'
import Cleave from 'vue-cleave-component'

import './assets/scss/main.scss'

Vue.config.devtools = true
Vue.use(VCalendar, { firstDayOfWeek: 2 })
Vue.use(Cleave)

var ok = false
try {
	window.DecidirSDK.setPublishableKey('d9c9c1e883c1413895d7d8cf6c1aa1d8')
	window.DecidirSDK.setTimeout(5000)
	ok = true
} catch (e) {
	swal.fire({ html: 'No se puede iniciar el formularo de pagos.', type: 'error' }).then(() =>
		location.replace('http://cearaevt.tur.ar/')
	)
}

if (ok) {
	router.beforeEach((to, from, next) => {
		to.meta.requiresAuth && (!store.state.user || typeof store.state.user != 'object')
			? next({ name: 'login', query: to.query })
			: next()
	})
	new Vue({ store, router, render: h => h(App) }).$mount('#app')
}
